import { createNumberMask } from 'redux-form-input-masks';

const dottedNumberMask = createNumberMask({
  decimalPlaces: 2,
  locale: 'pt-BR',
});

export default dottedNumberMask;
